export default __webpack_public_path__ + "locales/lv/ChangePhoneDialog.json?hash=18abb7ee98d8afb3e0987131d797aaf3";